export default {
  title: 'Categorie nouă',
  form: {
    menus: {
      label: 'Meniuri',
    },
    printer: {
      label: 'Imprimantă',
    },
    type: {
      label: 'Tip',
    },
    name: {
      label: 'Nume',
      placeholder: 'Introduceți numele categoriei',
    },
    description: {
      label: 'Descriere',
      placeholder: 'Introduceți descrierea',
    },
    has_combo_tax: {
      label: 'Are taxă combo',
    },
    modifier_groups: {
      label: 'Grupuri de modificatori',
    },
    image: {
      label: 'Imagine',
    },
    identifiers: {
      label: 'Identificatori',
    },
    has_separate_schedule: {
      label: 'Diferă de programul meniului',
    },
  },
  buttons: {
    save: 'Salvați',
    close: 'Închideți',
  },
  feedback: {
    missing_info: 'Informații lipsă',
  },
  toasts: {
    category_got_created: 'Categoria a fost creată',
    category_got_updated: 'Categoria a fost actualizată',
  },
};
